import React from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import './TrainingCalendar.css';

const localizer = momentLocalizer(moment);

const TrainingCalendar = ({ events }) => {
  // Transform training events to calendar format
  const calendarEvents = events.map(event => ({
    id: event.training_id,
    title: event.title,
    start: new Date(event.date),
    end: new Date(event.date),
    resource: event,
    allDay: true
  }));

  const eventStyleGetter = (event) => {
    return {
      style: {
        backgroundColor: '#6B46C1',
        borderRadius: '6px',
        opacity: 0.9,
        color: 'white',
        border: 'none',
        display: 'block',
        fontSize: '0.875rem',
        fontWeight: '500'
      }
    };
  };

  return (
    <div className="training-calendar-wrapper">
      <Calendar
        localizer={localizer}
        events={calendarEvents}
        startAccessor="start"
        endAccessor="end"
        style={{ height: 600, minHeight: 600 }}
        eventPropGetter={eventStyleGetter}
        views={['month', 'week', 'agenda']}
        defaultView="month"
        popup
        tooltipAccessor={(event) => `${event.title} - ${event.resource.venue}`}
      />
    </div>
  );
};

export default TrainingCalendar;
